import Features from 'Shared/LazyLoad/Features';
import ToggleComponent from 'Shared/LazyLoad/ToggleComponent';
import React, { Fragment } from 'react';

const Widgets = () => {
  return (
    <Fragment>
      <ToggleComponent feature={Features.ClarityWidget} />
    </Fragment>
  );
};

export default Widgets;
